<template>
    <div class="outer">
        <div class="inner">
            <authorization v-if="!isAuthorized" v-model="input" @clickConfirm="search" />
            <template v-else>
                <!-- 견적신청서 -->
                <inquiry-data :inquiry="inquiry" />
                <!-- 견적목록 -->
                <estimates :estimates="inquiry.estimates" @clickButton="openEstimate" />
            </template>
        </div>
        <!-- 견적팝업 -->
        <modal-portfolio-estimate v-if="portfolio" ref="popup-estimate" :portfolio="portfolio" />
    </div>
</template>
<script>
import Authorization from "@/components/client/estimate/inquiry/authorization.vue";
import InquiryData from "@/components/client/estimate/inquiry/inquiry-data.vue";
import api from "@/api";
import Estimates from "@/components/client/estimate/inquiry/estimates.vue";
import ModalPortfolioEstimate from "@/components/client/portfolio/estimate/modal-portfolio-estimate.vue";

export default {
    components: { Authorization, InquiryData, Estimates, ModalPortfolioEstimate },
    data() {
        return {
            _inquiry: null,
            isAuthorized: false,
            input: {
                name: null,
                phone1: null,
                phone2: null,
                phone3: null,
            },
            inquiry: null,
            portfolio: null,
        };
    },
    created() {
        this.$data._inquiry = this.$route.params._inquiry;
    },
    computed: {
        searchParams() {
            const {
                _inquiry: _id,
                input: { name, phone1, phone2, phone3 },
            } = this.$data;

            return { _id, name, phone: phone1 + phone2 + phone3 };
        },
    },
    methods: {
        async search() {
            try {
                const { inquiry, success } = await api.v1.portfolios.estimateInquiries.getEstimateInquiry(this.searchParams);

                this.inquiry = inquiry;
                this.isAuthorized = success;
            } catch (error) {
                console.log(error);
            }
        },

        handleError(error) {
            console.log(error);
            alert(error.response ? error.response.data.message : error.message);
        },

        openEstimate(estimate) {
            this.portfolio = { estimate };
            this.$nextTick(function() {
                this.$refs["popup-estimate"].modal = true;
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.outer {
    padding: 3rem 0;
}

.inner {
    margin: 0 auto;
    width: 50rem;
    padding: 3rem;
    box-shadow: 0 0.8rem 1.2rem 0 rgba(0, 0, 0, 0.1), 0 0.4rem 0.6rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 0.5rem;

    > :not(:first-child) {
        margin-top: 3rem;
    }
}
</style>
